<template>
    <div class="icon-wrap" v-if="hoverStyle">
        <svg
            v-if="icon"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
            :aria-labelledby="icon"
            class="pt-icon"
            @click="handleClick"
        >
            <use :xlink:href="['#' + icon]" />
        </svg>
    </div>
    <svg
        v-else-if="icon"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation"
        :aria-labelledby="icon"
        class="pt-icon"
        @click="handleClick"
    >
        <use :xlink:href="['#' + icon]" />
    </svg>
</template>

<script lang="ts">
export default {
    name: 'PtIcon',
};
</script>

<script lang="ts" setup>
interface Props {
    icon: string;
    hoverStyle?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
    icon: '',
    hoverStyle: false,
});
const emit = defineEmits<{
    (type: 'click', evt: Event): void;
}>();

function handleClick(evt: Event) {
    emit('click', evt);
}
</script>

<style lang="scss">
.icon-wrap {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    &:hover {
        background-color: #dfe1e6;
    }
}
.pt-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}
</style>
